import { Divider, Dropdown, Tag } from "antd";
import React, { useEffect, useState } from "react";
import svg78 from "../../../../assets/svg/svg78.svg";
import svg79 from "../../../../assets/svg/svg79.svg";
import svg80 from "../../../../assets/svg/svg80.svg";
import svg81 from "../../../../assets/svg/svg81.svg";
import svg82 from "../../../../assets/svg/svg82.svg";
import svg88 from "../../../../assets/svg/svg88.svg";
import { useDispatch, useSelector } from "react-redux";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import { Link } from "react-router-dom";
import PublishModal from "./modal/PublishModal";
import ConfirmModal from "../../../../components/ConfirmModal";
import {
  setActiveObj,
  setViewMode,
} from "../../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { formatText } from "../../../../utils";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import ShareJobModal from "./modal/ShareJobModal";

function JobHeader() {
  const dispatch = useDispatch();

  const activeObjJob = useSelector((state) => state.folder.activeObj["job"]);
  const viewMode = useSelector((state) => state.folder.viewMode);

  const urlCount = `api/v1/jobs/recruitmentStats?jobId=${activeObjJob?.jobId}`;

  const data = useSelector((state) => state.dropdown.data[urlCount] || []);

  const { open, handleCancel, handleOpen } = useModalToggle();
  const { saving } = useSelector((state) => state.save);
  const [selectedItem, setSelectedItem] = useState();
  const handleOpenDelete = async (item) => {
    await setSelectedItem(item);
    await handleOpen();
  };
  const handleCloseDelete = () => {
    handleCancel();
  };

  const handleDelete = async () => { 
    const res = await dispatch(
      save({
        url:selectedItem === "END_PROCESS" ? "api/v1/applications/end-recruitment" : "api/v1/jobs",
        jobId: activeObjJob?.jobId,
        jobAdvertStatus: selectedItem,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleCancel();
      await dispatch(
        setActiveObj({ key: "job", data: res?.payload?.data?.result })
      );
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const modalAdvertise = useModalToggle();
  const modalReadvertise = useModalToggle();
  const modalCancel = useModalToggle();
  const modalEndRecruitment = useModalToggle();

  const showAdvertiseModal = async (item) => {
    await setSelectedItem(item);
    await modalAdvertise.handleOpen();
    // modalAdvertise.showIf(activeObjJob?.jobAdvertStatus === "ACTIVE");
  };

  const [openMarks, setOpenMarks] = useState(false);
  const handleOpenMarks = async (item) => {
    await setOpenMarks(true);
  };
  const handleCloseMarks = async () => {
    await setOpenMarks(false);
  };

  const showReadvertiseModal = () => {
    modalReadvertise.showIf(
      new Date(activeObjJob?.jobAdvertEndDate) < new Date()
    );
  };

  const showModalCancel = () => {
    modalCancel.showIf(activeObjJob?.jobAdvertStatus !== "ACTIVE");
  };

  const showModalEndRecruitment = () => {
    modalEndRecruitment.showIf(activeObjJob?.jobAdvertStatus !== "ACTIVE");
  };

  const handleView = async () => {
    await dispatch(setViewMode(!viewMode));
  };

  const status = activeObjJob?.jobAdvertStatus;
  const statusColors = {
    PUBLISH: "#569D6E",
    RE_ADVERTISE: "#DAA520",
    ARCHIEVE: "#706F6F",
    CANCEL: "#FDB505",
    DRAFT: "#706F6F",
  };

  async function fectchCountData() {
    await dispatch(
      fetchData({
        url: urlCount,
        start: 0,
        limit: null,
      })
    );
  }

  const rawSettingItems = [
    {
      key: "6",
      visible:
        activeObjJob?.jobId && activeObjJob?.jobAdvertStatus != "PUBLISH",
      label: (
        <Link
          className="flex gap-x-[.75rem] items-center py-[.5rem]"
          onClick={handleView}
        >
          <img src={viewMode ? svg80 : svg88} alt="svg88" className="w-4 h-4" />{" "}
          {viewMode ? "Edit" : "View"}
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      visible:
        activeObjJob?.jobId && activeObjJob?.jobAdvertStatus != "PUBLISH",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={() => showAdvertiseModal("PUBLISH")}
        >
          <img src={svg81} alt="svg81" className="w-4 h-4" />
          <span className="whitespace-nowrap">Publish</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
    {
      key: "3",
      visible: activeObjJob?.jobAdvertStatus === "PUBLISH",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={() => handleOpenDelete("END_PROCESS")}
        >
          <img src={svg82} alt="svg82" className="w-4 h-4" />
          <span className="whitespace-nowrap">End Recruitment Process</span>
        </Link>
      ),
    },
    {
      key: "divider-3",
      type: "divider",
    },
    {
      key: "4",
      visible: activeObjJob?.jobAdvertStatus === "EXPIRED",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={() => showAdvertiseModal("REPUBLISH")}
        >
          <img src={svg81} alt="svg81" className="w-4 h-4" />
          <span className="whitespace-nowrap">Republish</span>
        </Link>
      ),
    },
    {
      key: "divider-4",
      type: "divider",
    },
    {
      key: "5",
      visible: activeObjJob?.jobAdvertStatus === "PUBLISH",
      label: (
        <Link
          className="flex items-center gap-x-2 py-[.5rem]"
          onClick={() => handleOpenDelete("CANCEL")}
        >
          <img src={svg82} alt="svg82" className="w-4 h-4" />
          <span className="whitespace-nowrap">Cancel</span>
        </Link>
      ),
    },
    {
      key: "divider-5",
      type: "divider",
    },
  ];

  const settingItems = rawSettingItems?.filter((item, index, arr) => {
    if (item?.type === "divider") {
      const prev = arr[index - 1];
      return prev && !!prev?.visible;
    }
    return !!item?.visible;
  });

  useEffect(() => {
    fectchCountData();
  }, []);
  return (
    <>
      <div className="job-pic p-[2.5rem] rounded-t-[8px] mt-[2rem]">
        <div className="flex justify-between lg:flex-row flex-col lg:items-center font-dmSans">
          <div className="text-[2rem] font-[500] text-white ">
            {activeObjJob?.jobId
              ? activeObjJob?.jobTitle
              : "New Job Advertisement"}
          </div>
          {activeObjJob?.jobId && (
            <div className="flex items-center gap-[1rem]">
              <span
                className="inline-block w-fit max-w-full py-[.25rem] px-[.5rem] rounded-[2.1875rem] text-xs font-normal  
              bg-[#E8EEED]"
                style={{ color: statusColors[status] || "#000" }}
              >
                {formatText(status)}
              </span>

              <div
                className="flex items-center gap-[.5rem] font-[400] text-[.875rem] text-white cursor-pointer"
                onClick={handleOpenMarks}
              >
                <img src={svg78} alt="svg78" />
                Share Job
              </div>
            </div>
          )}
        </div>

        <div className="text-[1.125rem] font-[500] text-white w-full lg:max-w-[800px]">
          {activeObjJob?.jobId
            ? activeObjJob?.jobBrief?.replace(/<[^>]+>/g, "")
            : "Advertise your job vacancies"}
        </div>

        {activeObjJob?.jobId && (
          <div className="flex lg:flex-row flex-col lg:items-center justify-between mt-[2.53rem] lg:gap-0 gap-3">
            <div className="flex items-center gap-[1rem]   flex-wrap   ">
              {data &&
                data?.map((item) => (
                  <div className="rounded-[2rem] border border-white/40 bg-[rgba(218,165,32,0.2)] backdrop-blur-[2.8px] py-[.5rem] px-[1rem] font-[500] text-[1rem] text-white">
                    <div className="flex items-center">
                      {" "}
                      {item?.title} {item?.count}
                    </div>
                  </div>
                ))}
            </div>

            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItems }}
              placement="bottom"
            >
              <button
                className="max-w-[7.0625rem]  py-0 px-[.75rem] gap-[.5rem] rounded-[1.625rem] border border-[#DAA520] bg-[#F9F9F9] flex items-center min-h-[2.5rem]"
                type="button"
              >
                Actions
                <img src={svg79} alt="svg79" />
              </button>
            </Dropdown>
          </div>
        )}
      </div>

      <PublishModal
        open={modalAdvertise.open}
        handleCancel={modalAdvertise.handleCancel}
        selectedItem={selectedItem}
      />
      <ConfirmModal
        open={open}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content={
          selectedItem === "CANCEL"
            ? "Are you sure you want to cancel this job"
            : selectedItem === "END_PROCESS"
            ? "Are you sure you want to end recruitment process for this job"
            : null
        }
        type="info"
        btnTitle="Confirm"
      />

      <ShareJobModal open={openMarks} handleCancel={handleCloseMarks} activeObjJob={activeObjJob}/>
      {/*  <Modal open={modalReadvertise.open} onCancel={modalReadvertise.handleCancel} />
<Modal open={modalCancel.open} onCancel={modalCancel.handleCancel} />
<Modal open={modalEndRecruitment.open} onCancel={modalEndRecruitment.handleCancel} /> */}
    </>
  );
}

export default JobHeader;
